import React, { useState } from 'react';
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  TextField,
  Alert,
  IconButton,
  Tooltip,
} from '@mui/material';
import {
  AdminPanelSettings as AdminIcon,
  Visibility as VisibilityIcon,
  VisibilityOff as VisibilityOffIcon,
  Login as LoginIcon,
} from '@mui/icons-material';
import { wolvesLabsColors } from '../../theme/wolvesLabsTheme';
import { useNavigate } from 'react-router-dom';

const HiddenAccess: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  // Contraseña oculta para acceder a Divertilandia
  const ADMIN_PASSWORD = 'enlu123';

  const handleAccess = () => {
    if (password === ADMIN_PASSWORD) {
      setOpen(false);
      setPassword('');
      setError('');
      navigate('/divertilandia/signin');
    } else {
      setError('Contraseña incorrecta');
    }
  };

  const handleDirectAccess = () => {
    navigate('/divertilandia/signin');
  };

  return (
    <>
      {/* Botón flotante invisible - Solo accesible si sabes dónde está */}
      <Box
        sx={{
          position: 'fixed',
          bottom: 20,
          right: 20,
          zIndex: 9999,
        }}
      >
        <Tooltip title="" placement="left">
          <IconButton
            onClick={() => setOpen(true)}
            onContextMenu={(e) => {
              e.preventDefault();
              handleDirectAccess();
            }}
            sx={{
              backgroundColor: 'transparent',
              color: 'transparent',
              width: 48,
              height: 48,
              transition: 'all 0.3s ease',
              opacity: 0,
              '&:hover': {
                backgroundColor: 'transparent',
                opacity: 0,
              },
            }}
          >
            <AdminIcon sx={{ fontSize: 24, opacity: 0 }} />
          </IconButton>
        </Tooltip>
      </Box>

      {/* Modal de acceso */}
      <Dialog
        open={open}
        onClose={() => {
          setOpen(false);
          setPassword('');
          setError('');
        }}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 0,
            backgroundColor: 'white',
          },
        }}
      >
        <DialogTitle
          sx={{
            textAlign: 'center',
            color: wolvesLabsColors.primary,
            fontWeight: 700,
            fontSize: '1.5rem',
          }}
        >
          Acceso Administrativo
        </DialogTitle>
        <DialogContent sx={{ p: 4 }}>
          <Box sx={{ textAlign: 'center', mb: 3 }}>
            <AdminIcon sx={{ fontSize: 60, color: wolvesLabsColors.accent, mb: 2 }} />
            <Typography variant="body1" sx={{ color: wolvesLabsColors.gray[600] }}>
              Ingresa la contraseña para acceder al sistema administrativo
            </Typography>
          </Box>

          <Box sx={{ mb: 3 }}>
            <TextField
              fullWidth
              type={showPassword ? 'text' : 'password'}
              label="Contraseña de acceso"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  handleAccess();
                }
              }}
              InputProps={{
                endAdornment: (
                  <IconButton
                    onClick={() => setShowPassword(!showPassword)}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                  </IconButton>
                ),
              }}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 0,
                },
              }}
            />
          </Box>

          {error && (
            <Alert severity="error" sx={{ mb: 2, borderRadius: 0 }}>
              {error}
            </Alert>
          )}

          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
            <Button
              variant="outlined"
              onClick={() => {
                setOpen(false);
                setPassword('');
                setError('');
              }}
              sx={{
                borderRadius: 0,
                borderColor: wolvesLabsColors.primary,
                color: wolvesLabsColors.primary,
                '&:hover': {
                  borderColor: wolvesLabsColors.accent,
                  backgroundColor: wolvesLabsColors.accent,
                  color: 'white',
                },
              }}
            >
              Cancelar
            </Button>
            <Button
              variant="contained"
              onClick={handleAccess}
              startIcon={<LoginIcon />}
              sx={{
                borderRadius: 0,
                backgroundColor: wolvesLabsColors.primary,
                '&:hover': {
                  backgroundColor: wolvesLabsColors.accent,
                },
              }}
            >
              Acceder
            </Button>
          </Box>

          <Box sx={{ mt: 3, p: 2, backgroundColor: wolvesLabsColors.light, borderRadius: 0 }}>
            <Typography variant="caption" sx={{ color: wolvesLabsColors.gray[600] }}>
              💡 <strong>Tip:</strong> También puedes hacer clic derecho en el botón de acceso para ir directamente
            </Typography>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default HiddenAccess;
